import { MessageSender, MessageStore } from "./types";

export const readMsgManager = ({
  set,
  get,
}: {
  set: (
    partial:
      | MessageStore
      | Partial<MessageStore>
      | ((state: MessageStore) => MessageStore | Partial<MessageStore>),
    replace?: false | undefined,
  ) => void;
  get: () => MessageStore;
}) => ({
  unreadCount: 0,
  bottomReached: false,
  setBottomReachedStatus: (status: boolean) => {
    set({ bottomReached: status });
  },
  // 标记消息为已读
  markMessageAsRead: (messageId: string) => {
    set((state) => {
      const updatedMessages = state.msgList.map((msg) =>
        msg.id === messageId || msg.clientId === messageId
          ? { ...msg, read: true }
          : msg,
      );

      // 计算新的未读数
      const newUnreadCount = updatedMessages.filter(
        (msg) => msg.senderType !== MessageSender.USER && !msg.read,
      ).length;

      return {
        msgList: updatedMessages,
        unreadCount: newUnreadCount,
      };
    });
  },

  // 重置未读数（例如用户打开聊天窗口时、或点击「新消息」回到底部时）
  resetUnreadCount: () => {
    set((state) => ({
      unreadCount: 0,
      msgList: state.msgList.map((msg) =>
        msg.senderType === MessageSender.AGENT && !msg.read
          ? { ...msg, read: true }
          : msg,
      ),
    }));
  },

  // 获取所有未读消息
  getUnreadMessages: () => {
    return get().msgList.filter(
      (msg) => msg.senderType === MessageSender.AGENT && !msg.read,
    );
  },
});
